import { removeToken } from '@/utils/auth'
import { Message } from 'element-ui'
import router from '@/router'

export default {
  SET_USERINFO(state, userInfo) {
    state.userInfo = userInfo
  },
  SET_PLATPARAM(state, platParam) {
    state.platParam = platParam
  },
  PUSH_CANCEL(state, payload) {
    state.cancelTokenArr.push(payload.cancelToken)
  },
  // 退出登录
  SET_LOGOUT(state, data) {
    const msg = '用户登录失效，请重新登录'
    Message.warning({
      dangerouslyUseHTMLString: true,
      message: msg,
      duration: 1000
    })
    removeToken()
    localStorage.removeItem('tokenValue')
    localStorage.removeItem('zq_userInfo')
    localStorage.removeItem('zq_userName')
    console.log('-----------login---------')
    router.push({
      path: '/login'
    })
  }
}
